import "./loader-success-fail.scss";
import m from "mithril";
import tools from "../../../old/tools/tools";
import button from "../button/index";

export default () => {
	let dom = undefined;
	let totaldom = undefined;
	let ErrorMessage = undefined;
	let finalResolve = undefined;
	let onbeforepromise1 = undefined;
	let onbeforepromise2 = undefined;

	const content = (message) => {
		return m(
			".loader-success-fail.loading",
			{
				oncreate: (u) => {
					totaldom = u.dom;
				},
				onbeforeremove: () => {
					if (finalResolve)
						return new Promise((resolve) => {
							onbeforepromise1 = resolve;
						});
				},
			},
			m(".loader", {
				oncreate: (u) => {
					dom = u.dom;
				},
				onbeforeremove: () => {
					if (finalResolve)
						return new Promise((resolve) => {
							onbeforepromise2 = resolve;
						});
				},
			}),
			(ErrorMessage || message) && m(".error-message", ErrorMessage || message),
			ErrorMessage &&
				m(button, {
					label: "OK",
					onclick: FadeOut,
				})
		);
	};

	const FadeOut = (success) => {
		if (!success) totaldom.classList.add("fade-out");
		totaldom.addEventListener("animationend", (e) => {
			console.log({e});
			if (totaldom)
				if (success) {
					tools.Wait(1000).then(() => {
						totaldom.classList.add("fade-out");
					});
				}
			if (e.animationName == "a-fade-out") {
				FinalResolve();
			}
		});
	};

	const FinalResolve = () => {
		if (finalResolve) finalResolve();
		if (onbeforepromise1) onbeforepromise1();
		if (onbeforepromise2) onbeforepromise2();

		// dom = undefined;
		// totaldom = undefined;
		// ErrorMessage = undefined;
		// finalResolve = undefined;
		// onbeforepromise1 = undefined;
		// onbeforepromise2 = undefined;
	};

	const AnimationStopFunction = (resolve) => {};

	return {
		Component: content,
		MarkComplete: async (success = true, errorMessage) => {
			if (dom) {
				return new Promise(function (resolve) {
					finalResolve = resolve;
					if (!success && errorMessage) ErrorMessage = errorMessage;
					m.redraw();
					dom.classList.add(success ? "success" : "fail");
					// if (success) FadeOut(true);
				});
			}
		},
	};
};
